// externals
import React, { useMemo, useState } from 'react';

// libraries
import type { CreditDecision } from '@makemydeal/dr-dash-types';
import { sortingUtils } from '@makemydeal/dr-dash-ui-utils';

// components
import { LenderDecisionCard } from './LenderDecisionCard';

// styles
import { CardWrapper } from './LenderDecisionInfo.style';

export type LenderListProps = {
    onCardSelected: (selectedLenderId: string) => void;
    lenderDecisions: CreditDecision[];
    sortOrder: any[];
    showFooter: () => void;
    setSelectedDecision: (selectedDecision: CreditDecision) => void;
};

export const LenderList = ({ onCardSelected, lenderDecisions, sortOrder, showFooter, setSelectedDecision }: LenderListProps) => {
    const sortedLenderDecisions = useMemo(() => {
        const copiedLenderDecisions = [...lenderDecisions];
        if (sortOrder.length === 0) {
            copiedLenderDecisions.sort((a, b) => (a.approvalStatus > b.approvalStatus ? 1 : -1));
        } else {
            copiedLenderDecisions.sort(sortingUtils.sortByStatusFunction);
        }
        return copiedLenderDecisions;
    }, [lenderDecisions, sortOrder]);

    const [lenderDecisonsList, setLenderDecisionList] = useState<CreditDecision[]>(sortedLenderDecisions);

    const handleCardSelected = (selectedLenderId: string) => {
        onCardSelected(selectedLenderId);
        let selectedLender: CreditDecision | undefined;

        const updatedList = lenderDecisonsList.map((lender) => {
            if (lender.lenderId === selectedLenderId) {
                const updatedLender = { ...lender, isActive: !lender.isActive };
                selectedLender = updatedLender;
                return updatedLender;
            } else {
                return { ...lender, isActive: false };
            }
        });

        if (selectedLender) {
            setSelectedDecision(selectedLender);
        }
        setLenderDecisionList(updatedList);
    };

    return (
        <CardWrapper data-testid="credit-decision-lender-list">
            {lenderDecisonsList.map((lenderDecision) => (
                <LenderDecisionCard
                    key={lenderDecision.lenderId}
                    isCardActive={lenderDecision.isActive || false}
                    onCardSelected={handleCardSelected}
                    data={lenderDecision}
                    showFooter={showFooter}
                />
            ))}
        </CardWrapper>
    );
};
